import React, { useEffect, useRef, useState } from "react";
import Styles from "./ThisModel.module.css";
import Modal from "@mui/material/Modal";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";
import documentUploadService from "../Services/documentUpload.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import bankingService from "../Services/banking.service";
import { pdfjs } from "react-pdf";
import { saveAs } from "file-saver";

const AgreementModel = ({ type, handleClose, open, dataL }) => {
  const [fileName, setFileName] = useState(false);
  const [docId, setDocId] = useState("");
  const [viewPrf, setViewPdf] = useState("");
  const pdfContainerRef = useRef(null);
  const [isPdfData, setIsPdfData] = useState(false);
  const [scale, setScale] = useState(1);

  const [activeType, setActiveType] = useState("none");
  const [genCheck, setGenCheck] = useState(false);

  useEffect(() => {
    if (type === "LOI") {
      setDocId(dataL?.loiDocumentId);
    } else {
      setDocId(dataL?.agreementDocumentId);
    }
  }, [dataL]);

  const getBankingLedger = () => {
    bankingService.getBankingLedger().then((response) => {
      if (response?.data?.code === 200) {
        toast.success("Uploaded Successfully", toastProperties);
      } else if (response?.data?.code !== 200) {
      }
    });
  };

  const handleProofOfPayment = (e, type) => {
    const fun = async (e) => {
      const fileList = e?.target?.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        let extension = file.name.split(".").pop();
        let fileSize = file.size / 1024 / 1024;
        let extList = ["pdf"];
        if (fileSize < 10) {
          if (extList.includes(extension)) {
            let formData = new FormData();
            formData.append("file", file);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };
            let data = (
              await documentUploadService.documentUpload(type, formData, config)
            )?.data;
            if (data?.data) {
              setFileName(data?.data?.fileName);
              setDocId(data?.data?.id);
              toast.success("Uploaded Successfully", toastProperties);
              if (type === "LOI") {
                handleUpdatePatchInd(data?.data?.id);
              } else {
                handleUpdatePatchAgr(data?.data?.id);
              }
              handleViewDoc(data?.data?.id);
            } else {
              toast.error("Failed to upload File", toastProperties);
              // setFieldValue(key, "");
            }
          } else {
            // setFieldValue(key, "");
            toast.error("Only Pdf formats can be uploaded", toastProperties);
          }
        } else {
          toast.error("File Size Cannot Exceed 10mb", toastProperties);
          //  setFieldValue(key, "");
        }
      } else {
      }
    };
    fun(e);
  };

  const handleUpdatePatchAgr = async (id) => {
    let payload = {
      id: dataL?.id,
      agreementDocumentId: id,
    };
    let res = await bankingService.updateDocument(payload);
    if (res?.data?.code == 200) {
      toast.success("Uploaded Successfully", toastProperties);
      getBankingLedger();
    }
  };

  const handleUpdatePatchInd = async (id) => {
    let payload = {
      id: dataL?.id,
      loiDocumentId: id,
    };
    let res = await bankingService.updateDocument(payload);
    if (res?.data?.code == 200) {
      toast.success("Uploaded Successfully", toastProperties);
      getBankingLedger();
    }
  };

  const handleViewDoc = async (id) => {
    setActiveType("view");
    let res = await documentUploadService.getDocumentById(id);
    let pdfUrl = `data:application/pdf;base64,${res?.data?.data?.fileInBytes}`;
    renderPdfToContainer(pdfUrl);
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'document.pdf';
    link.click();
  };

  const renderPdfToContainer = async (pdfUrlData) => {
    try {
      const pdf = await pdfjs.getDocument(pdfUrlData).promise;
      const numPages = pdf.numPages;
      if (pdf) {
        setIsPdfData(true);
      }
      for (let pageNum = 1; pageNum <= numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1 });

        const screenHeight = window.innerHeight;
        const newScale = screenHeight / viewport.height;
        setScale(newScale);
        //   const newScale = scale;
        const canvas = document.createElement("canvas");
        canvas.height = viewport.height * newScale;
        canvas.width = viewport.width * newScale;
        const context = canvas.getContext("2d");

        const renderContext = {
          canvasContext: context,
          viewport: page.getViewport({ scale: newScale }),
        };

        await page.render(renderContext);
        pdfContainerRef.current.appendChild(canvas);
      }
    } catch (error) {
      console.error("Error rendering PDF:", error);
    }
  };

  const handleDownload = async (type) => {
    let res = await bankingService.getLoaDocument(dataL?.id, type);
    if (!res?.data?.data?.available) {
      toast.error(
        "Please request your Company's Admin User to configure the LOI template",
        toastProperties
      );
      return;
    }
    const base64Data = res?.data?.data?.fileInBytes;
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    toast.success(
      "Document generated Successfully",
      toastProperties
    );
    saveAs(blob, "LOI.docx");
  };

  const handleView = (data) => {
    setActiveType(data);
    if (data === "view") {
      handleViewDoc(docId);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={Styles.modalContainer}>
          <div className={Styles.modalHeaderSec}>
            <div>
              View and Upload{" "}
              {type === "LOI" ? "Letter of Intent" : "Agreement"}
            </div>
            <div onClick={handleClose} style={{ cursor: "pointer" }}>
              <CloseIcon />
            </div>
          </div>
          <div className={Styles.modalDescContainer}>
            <div className={Styles.buttonContainer}>
              {type === "LOI" && (
                <div
                  className={
                    activeType === "generate"
                      ? Styles.eachButtonActive
                      : Styles.eachButtonInactive
                  }
                  onClick={() => handleView("generate")}
                >
                  Generate
                </div>
              )}
              <div
                className={
                  activeType === "upload"
                    ? Styles.eachButtonActive
                    : Styles.eachButtonInactive
                }
                onClick={() => handleView("upload")}
              >
                Upload
              </div>
              {docId && (
                <div
                  className={
                    activeType === "view"
                      ? Styles.eachButtonActive
                      : Styles.eachButtonInactive
                  }
                  onClick={() => handleView("view")}
                >
                  View
                </div>
              )}
            </div>
            <div className={Styles.viewContainerModal}>
              {activeType === "none" && (
                <div className={Styles.textNoneAlert}>
                  Please select the left section element
                </div>
              )}
              {activeType === "generate" && (
                <>
                  {genCheck ? (
                    <div className={Styles.selectTypeCont}>
                      <div className={Styles.secTextType}>
                        Please Select the Document Generate type
                      </div>
                      <div className={Styles.buttonAreaCont}>
                        <div onClick={() => handleDownload("0")}>Self</div>
                        <div onClick={() => handleDownload("1")}>
                          Counter Party
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div
                        onClick={() => setGenCheck(true)}
                        className={Styles.genDocsButton}
                      >
                        Generate Document
                      </div>
                    </div>
                  )}
                </>
              )}
              {activeType === "upload" && (
                <div>
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className={Styles.docsinputFile}
                  >
                    <input
                      type="file"
                      onChange={(e) => handleProofOfPayment(e, type)}
                      id="input-file"
                    />
                    <label
                      className={Styles.docsinputLabel}
                      htmlFor="input-file"
                    >
                      <AttachFileIcon style={{ height: "16px" }} />
                      <span>
                        {type === "LOI"
                          ? fileName || "Upload Letter of Intent"
                          : fileName || "Upload Agreement"}
                      </span>
                    </label>
                  </div>
                </div>
              )}
              {activeType === "view" && (
                <div className={Styles.pdfViewContainer}>
                  <div
                    ref={pdfContainerRef}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      alignItems: "center",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AgreementModel;
